webpackJsonp([174759553322802],{

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ArticlesPageHero40@2x.e722f99e.jpg";

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _g$div;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(13);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _reactHelmet = __webpack_require__(38);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _layoutUnits = __webpack_require__(21);
	
	var _banner = __webpack_require__(26);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _responsiveMargin = __webpack_require__(27);
	
	var _responsiveMargin2 = _interopRequireDefault(_responsiveMargin);
	
	var _sitenav = __webpack_require__(28);
	
	var _sitenav2 = _interopRequireDefault(_sitenav);
	
	var _ArticlesPageHero402x = __webpack_require__(659);
	
	var _ArticlesPageHero402x2 = _interopRequireDefault(_ArticlesPageHero402x);
	
	var _ca_advertising_annual_ = __webpack_require__(663);
	
	var _ca_advertising_annual_2 = _interopRequireDefault(_ca_advertising_annual_);
	
	var _commarts = __webpack_require__(367);
	
	var _commarts2 = _interopRequireDefault(_commarts);
	
	var _pdn = __webpack_require__(665);
	
	var _pdn2 = _interopRequireDefault(_pdn);
	
	var _pdnSisterhood = __webpack_require__(369);
	
	var _pdnSisterhood2 = _interopRequireDefault(_pdnSisterhood);
	
	var _pdn3 = __webpack_require__(664);
	
	var _pdn4 = _interopRequireDefault(_pdn3);
	
	var _pdnDocumentary = __webpack_require__(368);
	
	var _pdnDocumentary2 = _interopRequireDefault(_pdnDocumentary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArticleEntryContainer = _glamorous2.default.div({
	  display: 'flex',
	  flexWrap: 'wrap',
	  alignItems: 'flex-start',
	  margin: _layoutUnits.normalMargin + ' 0 0'
	});
	
	var ArticleImage = _glamorous2.default.img({
	  flex: 2,
	  width: 0,
	  maxWidth: '180px',
	  boxShadow: '1px 2px 4px 0 rgba(0, 0, 0, 0.15)'
	});
	
	var ArticleText = _glamorous2.default.div((_g$div = {
	  flex: 3,
	  marginLeft: _layoutUnits.normalMargin
	}, _g$div['@media (min-width: ' + _layoutUnits.largeBreakpoint + ')'] = {
	  marginLeft: _layoutUnits.largeMargin
	}, _g$div));
	
	var ArticleTitleLink = _glamorous2.default.a({
	  display: 'block',
	  marginBottom: _layoutUnits.smallMargin
	});
	
	var ArticleEntry = function ArticleEntry(_ref) {
	  var imgUrl = _ref.imgUrl,
	      articleUrl = _ref.articleUrl,
	      articleTitle = _ref.articleTitle,
	      pubTitle = _ref.pubTitle,
	      pubDate = _ref.pubDate;
	  return Glamor.createElement(
	    ArticleEntryContainer,
	    null,
	    Glamor.createElement(ArticleImage, { src: imgUrl }),
	    Glamor.createElement(
	      ArticleText,
	      null,
	      Glamor.createElement(
	        ArticleTitleLink,
	        { target: '_blank', href: articleUrl },
	        articleTitle
	      ),
	      Glamor.createElement(
	        'div',
	        null,
	        Glamor.createElement(
	          'em',
	          null,
	          pubTitle
	        ),
	        ', ',
	        pubDate
	      )
	    )
	  );
	};
	
	exports.default = function () {
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(_reactHelmet2.default, { title: 'Articles | Sarah Coleman' }),
	    Glamor.createElement(_banner2.default, { imageUrl: _ArticlesPageHero402x2.default }),
	    Glamor.createElement(_sitenav2.default, null),
	    Glamor.createElement(
	      _responsiveMargin2.default,
	      { css: { maxWidth: '640px' } },
	      Glamor.createElement(
	        'h2',
	        null,
	        'Articles'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'Sarah wrote about history, people and trends in photography for over 20 years. Berenice Abbott might have enjoyed skimming these ones.'
	      ),
	      Glamor.createElement(
	        _glamorous2.default.Div,
	        { display: 'flex', flexDirection: 'column' },
	        Glamor.createElement(ArticleEntry, {
	          imgUrl: _ca_advertising_annual_2.default,
	          articleUrl: _commarts2.default,
	          articleTitle: 'Shooting for Change: Women Photojournalists Reshape Our View of the World',
	          pubTitle: 'Communication Arts',
	          pubDate: '2015' }),
	        Glamor.createElement(ArticleEntry, {
	          imgUrl: _pdn2.default,
	          articleUrl: _pdnSisterhood2.default,
	          articleTitle: 'Sisterhood',
	          pubTitle: 'Photo District News',
	          pubDate: 'September 2015' }),
	        Glamor.createElement(ArticleEntry, {
	          imgUrl: _pdn4.default,
	          articleUrl: _pdnDocumentary2.default,
	          articleTitle: 'Documentary Photographers, Emotional Complications',
	          pubTitle: 'Photo District News',
	          pubDate: 'May 2007' })
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ca_advertising_annual_2015.5433c626.jpg";

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/commarts.d36ec9a3.pdf";

/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pdn-200705.6c5d4852.jpg";

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pdn-201509.ee8c2b8e.jpg";

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pdn-documentary.e7664471.pdf";

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pdn-sisterhood.853fce93.pdf";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-articles-js-bc04c09a96a87ec5bcb3.js